'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery/dist/jquery.slim');

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

require('angular-sanitize');

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _uiComponents = require('./ui-components');

var _uiComponents2 = _interopRequireDefault(_uiComponents);

var _magazine = require('./magazine');

var _magazine2 = _interopRequireDefault(_magazine);

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _nvd = require('nvd3');

var _nvd2 = _interopRequireDefault(_nvd);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb', [_core2.default.name, _uiComponents2.default.name, _magazine2.default.name]);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/index.js
// module id = 426
// module chunks = 0